(function () {
  'use strict';

  /* @ngdoc object
   * @name aircraftRegistration
   * @description
   *
   */
  angular
    .module('aircraftRegistration', [
      'ui.router'
    ]);
}());
